module.exports = __webpack_public_path__ + "img/american-express.444731bb.svg";